var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0122 1.17188C6.29405 1.17188 0.822266 6.64041 0.822266 13.3586C0.822266 20.0767 6.29405 25.5448 13.0122 25.5448C19.671 25.5448 25.103 20.1596 25.1989 13.3683C25.1989 13.3647 25.1989 13.3614 25.1989 13.3577C25.1989 12.9121 24.832 12.5452 24.3864 12.5452C24.386 12.5452 24.3856 12.5452 24.3856 12.5452H13.8223V1.98194C13.8206 1.53831 13.4562 1.1735 13.0122 1.17188ZM12.1989 2.96059V13.359C12.1989 13.805 12.5657 14.1719 13.0114 14.1719H23.4037C22.8983 19.6883 18.5124 23.9215 13.0122 23.9215C7.17358 23.9215 2.44889 19.1972 2.44889 13.3586C2.44889 7.80837 6.76164 3.39609 12.1989 2.96059Z",
    fill: "#948FB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8618 1.53125C15.8594 1.53125 15.8569 1.53125 15.8545 1.53125C15.4088 1.53125 15.042 1.89809 15.042 2.34375V10.5183C15.042 10.964 15.4088 11.3308 15.8545 11.3308H24.0213C24.467 11.3304 24.8334 10.9636 24.8334 10.5183C24.8334 10.4464 24.8237 10.3749 24.805 10.3058C23.6273 5.96141 20.2838 2.64844 16.0568 1.55766C15.9934 1.541 15.9276 1.53206 15.8618 1.53125ZM16.6686 3.71322C19.4145 4.77028 21.5347 6.87466 22.6462 9.70419H16.6686V3.71322Z",
    fill: "#948FB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioIcon);
export default __webpack_public_path__ + "static/media/portfolio-icon.dc1a4a828ca3de896ac67a72bd004290.svg";
export { ForwardRef as ReactComponent };